export default[
    {
        path: '/dataList/productDeposit',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '产品寄存',
            authLogin: true
        }
    }
]